/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Skeleton, Table, Tooltip, Typography } from 'antd';
import {
  MoreOutlined,
  RightCircleOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import MaintenanceTypes from './MaintenanceTypes';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  deleteAdminEquipTypes,
  fetchAdminEquipTypes,
  fetchAdminPihEquipTypes,
} from '../../redux/admin/equipmentTypes/action';
import EquipmentsNo from './EquipmentsNo';
import {
  fetchAdminEquipSno,
  fetchAdminEquipTypeSno,
  fetchAdminEquipSubTypeSno,
  fetchAdminEquipDocType,
} from '../../redux/admin/equipmentSno/action';
import EquipSubCategory from './EquipSubCategory';
import DocumentList from './DocumentList';
import CommonAGGridTable from '../AG Grid/CommonAGGridTable';

const { Text } = Typography;

const DocEquipmentTypes = (props) => {
  const {
    openPage,
    setOpenPage,
    setOpenModel,
    openModal,
    checkOpen,
    setChecksOpen,
    equipTypeList,
    setEquipTypeList,
    categoryDataList,
    categoryData,
    adminEquipTypesLoading,
    equipmentType,
    setEquipmentType,
    equipTypeForm,
    editModelValue,
    setEditModelValue,
    setEditRecord,
    editRecord,
    OnclearEquipType,

    onDeleteEquipType,
    isEquipTypeDeleteLoading,
    adminEquipTypeSnoData,
    adminEquipTypeSnoLoad,
    onGetEquipSno,
    equipTypeSearchForm,
    clear,
    setClear,
    adminEquipTypesTotalCount,
    onGetPihEquipmentTypes,
    paginationClear,
    setPaginationClear,
    onFetchAdminEquipSubType,
    onFetchAdminEquipDocType,
    equipmentFormData,
    //
    setDocumentId,
    documentId,
    equipmentSubTypeId,
    setEquipmentSubTypeId,
    handleSetForm,
    setSubCategoryPageActive,
    setDocumentPageActive,
    searchCriteria,
    setSearchCriteria,
    onOpenAddDocumentModal,
  } = props;

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteEquipId, setDeleteEquipId] = useState('');
  const [equipmentTypeId, setEquipmentTypeId] = useState();
  const [equipmentTypeName, setEquipmentTypeName] = useState();
  const [equipmentSubTypeName, setEquipmentSubTypeName] = useState();
  const [openSubEquip, setOpenSubEquip] = useState('');
  const [closeDocList, setCloseDocList] = useState('');
  const [prevClickCount, setPrevClickCount] = useState(0);

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [subTypeTableList, setSubTypeTableList] = useState([]);
  const [subTypeName, setSubTypeName] = useState('');

  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(10000);

  const [adminEquipTypeSnoDataList, setAminEquipTypeSnoDataList] = useState([]);

  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);

  const generateColumns = async () => {
    const columnDefs = [
      {
        headerName: '  S.No',
        field: 'sno',
        maxWidth: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        suppressMovable: true,
        lockPosition: true,
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Equipment Type',
        field: 'pihEquipmentType',
        width: 200,
        sortable: true,
        filter: true,
        cellStyle: { textAlign: 'left' },
        headerClass: 'ag-center-header',
        suppressMovable: true,
        lockPosition: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Actions',
        field: 'editDelete',
        width: 150,
        pinned: 'right',
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <div className="tableIcons">
              <Tooltip
                title="View manuals & diagrams"
                placement="top"
              >
                <RightCircleOutlined
                  className="icon-22"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={async () => {
                    setChecksOpen(true);
                    setOpenPage('');
                    equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
                    setEquipmentTypeName(record.pihEquipmentType);

                    setEquipmentSubTypeName(record.pihEquipmentType);
                    setEquipmentSubTypeId(record.id);
                    equipmentFormData.setFieldsValue({ pihCategory: record.pihEquipmentType });
                    // setEquipmentTypeId(record.id);
                    // console.log(record)
                    // equipmentFormData.setFieldsValue({ pihEquipment: record.pihEquipmentType });
                    //await onFetchAdminEquipSubType({ pihEquipmentTypeCategory: record.equipmentTypeCategory });
                  }}
                />
              </Tooltip>
            </div>
          );
        },
        cellStyle: { textAlign: 'center' },
        filter: false,
        suppressMovable: true,
      },
    ];

    // console.log(columnList, columnDefs);
    setColumnDefs(columnDefs);
    return columnDefs;
  };
  useEffect(() => {
    generateColumns();
  }, []);

  useEffect(() => {
    (async () => {
      var obj = {
        pageSize: currentPagesize,
        pageNumber: searchCriteria != '' ? 1 : currentPageNumber,
        searchKey: searchCriteria,
      };

      await onGetPihEquipmentTypes(obj);
    })();
  }, [searchCriteria]);

  useEffect(() => {
    if (adminEquipTypeSnoData) setAminEquipTypeSnoDataList(adminEquipTypeSnoData);
  }, [adminEquipTypeSnoData]);

  useEffect(() => {
    if (categoryData && categoryData.length > 0) {
      // Filter out items with empty/null/undefined/whitespace-only equipment types
      let filteredData = categoryData.filter((item) => {
        const type = item.pihEquipmentType;
        return type && type.trim() !== '';
      });

      // Remove duplicates based on pihEquipmentType (case-insensitive)
      const seen = new Set();
      const uniqueData = filteredData.filter((item) => {
        const key = item.pihEquipmentType.trim().toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      // Sort alphabetically (case-insensitive)
      uniqueData.sort((a, b) =>
        a.pihEquipmentType
          .trim()
          .toLowerCase()
          .localeCompare(b.pihEquipmentType.trim().toLowerCase())
      );

      setSubTypeTableList(uniqueData);
    }
  }, [categoryData]);

  const RemoveDuplicates = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  };
  const typesListColumns = [
    {
      title: 'Equipment Types',
      dataIndex: 'pihEquipmentType',
      key: 'pihEquipmentType',
      align: 'left',
      // sorter: (a, b) => {return (a-b)},
      ellipsis: true,
    },
    {
      title: () => {
        return <MoreOutlined style={{ fontSize: '18px' }} />;
      },
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: '100px',
      render: (text, record) => {
        return (
          <div className="tableIcons">
            <Tooltip
              title="View manuals & diagrams"
              placement="top"
            >
              <RightCircleOutlined
                className="icon-22"
                onClick={async () => {
                  setChecksOpen(true);
                  setOpenPage('');
                  equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
                  setEquipmentTypeName(record.pihEquipmentType);

                  setEquipmentSubTypeName(record.pihEquipmentType);
                  setEquipmentSubTypeId(record.id);
                  equipmentFormData.setFieldsValue({ pihCategory: record.pihEquipmentType });
                  // setEquipmentTypeId(record.id);
                  // console.log(record)
                  // equipmentFormData.setFieldsValue({ pihEquipment: record.pihEquipmentType });
                  //await onFetchAdminEquipSubType({ pihEquipmentTypeCategory: record.equipmentTypeCategory });
                }}
              />
            </Tooltip>
          </div>
        );
      },
      align: 'center',
    },
  ];

  /** Setting values for updating equipment types */
  const setEditModel = (record) => {
    setOpenModel(true);
    setEditRecord(record);
    setEditModelValue(true);
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setDeleteModal(false);
    setDeleteEquipId('');
  };

  /** Waiting to delete equipment type and close Modal */
  useEffect(() => {
    if (!isEquipTypeDeleteLoading) {
      setDeleteModal(false);
      setDeleteEquipId('');
      // OnclearEquipType();
      setClear(false);
      equipTypeSearchForm.resetFields();
      setPaginationClear(false);
    }
  }, [isEquipTypeDeleteLoading]);

  return (
    <div>
      {!checkOpen && openPage != 'documentList' ? (
        <div>
          <Row gutter={24}>
            <Col
              span={24}
              style={{ padding: '0px 12px 0' }}
            >
              <CommonAGGridTable
                rowData={equipTypeList}
                columnDefs={columnDefs}
                activeKeyLine="List of Equipment Types"
                isRawListLoading={equipTypeList.length === 0 || adminEquipTypesLoading}
                loadingMessage="Loading Equipment Types..."
                //onSelectionChanged={handleSelectionChanged}
              />
            </Col>
          </Row>
        </div>
      ) : (
        <div>
          <div className="back_equip">
            <Tooltip title={' Back'}>
              {' '}
              <ArrowLeftOutlined
                onClick={() => {
                  setChecksOpen(false);
                  setOpenPage('');
                  if (!clear) {
                    equipTypeSearchForm.resetFields();
                    OnclearEquipType();
                    setAminEquipTypeSnoDataList([]);
                    setEquipmentTypeName('');
                  }
                }}
              />
            </Tooltip>
            <Text style={{ fontSize: '16px', paddingLeft: '10px' }}>{equipmentTypeName}</Text>
          </div>

          <div style={{ marginTop: '12px' }}>
            <DocumentList
              equipmentTypeId={equipmentTypeId}
              equipmentSubTypeId={equipmentSubTypeId}
              documentId={documentId}
              setDocumentId={setDocumentId}
              equipmentSubTypeName={equipmentSubTypeName}
              equipmentTypeName={equipmentTypeName}
              handleSetForm={handleSetForm}
              onOpenAddDocumentModal={onOpenAddDocumentModal}
            />
            {/* <EquipmentsNo
                                    adminEquipTypeSnoData={adminEquipTypeSnoData}
                                    adminEquipTypeSnoLoad={adminEquipTypeSnoLoad}
                                    equipmentTypeName={equipmentTypeName}
                                    equipmentTypeId={equipmentTypeId}
                                    setEquipmentTypeId={setEquipmentTypeId}
                                /> */}
          </div>
        </div>
      )}
      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Delete Equipment Type"
        centered
        visible={deleteModal}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
          >
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={() => onDeleteEquipType({ pihEquipmentType: deleteEquipId.pihEquipmentType })}
            loading={isEquipTypeDeleteLoading}
          >
            {isEquipTypeDeleteLoading ? 'Deleting' : 'Confirm'}
          </Button>,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            <p>
              Deleting Equipment Type will delete all the corresponding Equipments and related
              information.
            </p>
            Are you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>{deleteEquipId && deleteEquipId.pihEquipmentType}</b>{' '}
            Equipment Type?
          </Text>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ adminEquipTypeReducer, adminEquipSnoReducer }) => {
  const adminEquipTypes = get(adminEquipTypeReducer, 'adminEquipTypes', []);
  const adminEquipTypesTotalCount = get(adminEquipTypeReducer, 'adminEquipTypesTotalCount', null);
  const adminEquipTypesLoading = get(adminEquipTypeReducer, 'adminEquipTypesLoading', false);
  const isEquipTypeDeleteLoading = get(adminEquipTypeReducer, 'isEquipTypeDeleteLoading', false);
  const adminEquipTypeSnoLoad = get(adminEquipSnoReducer, 'adminEquipTypeSnoLoad', false);
  const adminEquipTypeSnoData = get(adminEquipSnoReducer, 'adminEquipTypeSnoData', []);
  return {
    adminEquipTypes,
    adminEquipTypesLoading,
    isEquipTypeDeleteLoading,
    adminEquipTypeSnoData,
    adminEquipTypeSnoLoad,
    adminEquipTypesTotalCount,
  };
};

const mapDispatchToProps = {
  onDeleteEquipType: deleteAdminEquipTypes,
  onGetEquipSno: fetchAdminEquipTypeSno,
  onGetPihEquipmentTypes: fetchAdminPihEquipTypes,
  onFetchAdminEquipSubType: fetchAdminEquipSubTypeSno,
  onFetchAdminEquipDocType: fetchAdminEquipDocType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocEquipmentTypes);
